// extracted by mini-css-extract-plugin
export var container = "S6ii7HpIg17Ju9DPJofL";
export var icon = "eewOlbfXC7MlSDVEtfPM";
export var paddedContent = "BpNjHwXBRXPlMTL7CVKi";